module.exports = __webpack_public_path__ + "static/assets/4fa98fac3fd7824345a9884a9460f3ce.svg";